<!-- HelpCenter -->
<template>
  <div class="container">
    <div class="header">
      <div class="header-box">
        <h1 class="header-title">常见问题</h1>
        <img class="header-search-icon" src="@/assets/helpCenter/search.png" alt="" @click="goSearch">
      </div>
    </div>
    <div class="help-box">
      <div class="help-item" v-for="item in helpFormwork.list" :key="item.title" @click="()=>{goHelpPage(item.id, item.title)}">
        <div class="help-item-icon" :style="{'background-image': `url(${item.iconUrl})`}">
          <img class="icon-corner" src="@/assets/helpCenter/hot.png" alt="" v-if="item.hotIcon">
        </div>
        <h2 class="help-item-title">{{item.title}}</h2>
      </div>
      <template v-if="helpFormwork.list.length % cols > 0">
        <div class="help-item" v-for="(item, index) in (cols - helpFormwork.list.length % cols)" :key="index"></div>
      </template>
    </div>

    <div class="help-tip">如有任何问题，请联系客服（工作时间10:00-18:00）</div>

    <div class="help-contact">
      <div class="contact-item">
        <img class="contact-item-icon" src="@/assets/helpCenter/icon_tel.png" alt="">
        <h1 class="contact-item-title">客服电话：<a class="contact-item-content" :href="'tel:'+helpFormwork.tel">{{helpFormwork.tel}}</a></h1>
      </div>
      <div class="contact-item">
        <img class="contact-item-icon" src="@/assets/helpCenter/icon_wechat.png" alt="">
        <h1 class="contact-item-title">微信公众号：<span class="contact-item-content">{{helpFormwork.wechat}}</span></h1>
      </div>
    </div>

    <div class="btn-feedback" v-if="isShowCustomerService" @click="goCustomerService"><div class="btn-feedback-unread" v-if="isUnread"></div>投诉建议</div>
  </div>
</template>

<script>
import config from '@/config/config'
import helpData from './help_config'
import helpDataWatch from './help_config_watch'
import { getAppVersion, compareVersion, isIlistenIos, isIlistenAndroid } from '@/utils/app-helper'

export default {
  components: { },
  data() {
    return {
      helpFormwork: { list: [] },
      cols: 3, // 列数
      isShowCustomerService: false,
      isUnread: false
    }
  },
  created() {
    this.initData()
    this.initCustomerService()
    if (this.$route.query.unread > 0) {
      this.isUnread = true
    }
  },
  methods: {
    initData () {
      switch (this.$route.query.type) {
        case 'watch':
          this.helpFormwork = helpDataWatch
          break
        default:
          this.helpFormwork = helpData
      }
    },

    goSearch () {
      const _this = this
      _this.$router.push({
        path: 'helpsearch',
        query: {
          type: _this.$route.query.type
        }
      })
    },

    goCustomerService () {
      let appVersion = getAppVersion()
      if (isIlistenIos() && compareVersion(appVersion, '11.1.0') >= 0) {
        window.location.href = 'ilisten:///contactservice/chat'
      } else if (isIlistenAndroid() && compareVersion(appVersion, '10.16.0') >= 0) {
        window.location.href = 'ilisten:///contactservice/chat'
      } else {
        this.$toast.show({
          text: '客户端版本过低<br>请升级到最新版本'
        })
      }
    },

    initCustomerService () {
      let appVersion = getAppVersion()
      if ((isIlistenIos() && compareVersion(appVersion, '11.1.0') >= 0) 
        || (isIlistenAndroid() && compareVersion(appVersion, '10.16.0') >= 0)) {
        this.isShowCustomerService = true
      }
    },

    goHelpPage (id, title) {
      const _this = this
      window.location.href = `${config.siteRoot}/helppage?type=${_this.$route.query.type}&title=${title}&id=${id}`
    },
  },
}
</script>

<style scoped lang="less">
@import "~@/styles/fn";

.container {
  background: #f4f4f8;
  min-height: 100vh;
  box-sizing: border-box;
}

.header {
  display: block;
  padding: 0 .4rem;
  background: #fff;
  .header-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: inset 0 -1px 0 0 #FAFAFA;
  }
  &-title {
    height: .96rem;
    line-height: .96rem;
    color: #2c2a40;
    font-size: .32rem;
  }
  &-search-icon {
    display: block;
    width: 1.82rem;
    height: .68rem;
  }
}

.help-box {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: .24rem 0rem .06rem 0rem;
  background: #fff;
  .help-item {
    flex: 1 1 33.33%;
    width: 1.38rem;
    margin-bottom: .38rem;
    &-icon {
      position: relative;
      display: block;
      margin: 0 auto;
      width: 1.38rem;
      height: 1.38rem;
      background-position: center;
      background-size: cover;
      background-repeat: no-repeat;
      border-radius: 50%;
      .icon-corner {
        position: absolute;
        display: block;
        right: 0;
        top: 0;
        width: .38rem;
        height: .38rem;
        border-radius: 50%;
      }
    }
    &-title {
      margin-top: .22rem;
      color: #2c2a40;
      font-size: .28rem;
      font-weight: bold;
      text-align: center;
    }
  }
}

.help-contact {
  background: #fff;
  padding: 0 .36rem;
  .contact-item {
    display: flex;
    align-items: center;
    height: 1.2rem;
    box-shadow: inset 0 -1px 0 0 #FAFAFA;
    &-icon {
      display: block;
      margin-right: .2rem;
      width: .48rem;
      height: .48rem;
      border-radius: 50%;
    }
    &-title {
      color: #4a4a4a;
      font-size: .32rem;
      font-weight: normal;
      text-decoration: none;
    }
    &-content {
      color: #f3bb40;
      font-size: .32rem;
      text-decoration: none;
      font-weight: normal;
    }
  }
}

.help-tip {
  padding: .46rem .24rem .18rem .24rem;
  color: #a0a0a6;
  font-size: .24rem;
}

.btn-feedback {
  position: relative;
  display: block;
  margin: 0 auto;
  margin-top: .9rem;
  width: 5.6rem;
  height: 1.02rem;
  line-height: 1.02rem;
  color: #604038;
  font-size: .34rem;
  font-weight: bold;
  text-align: center;
  background: linear-gradient(135deg, #fedc42, #feb800);
  border-radius: 200px;
  &-unread {
    position: absolute;
    display: block;
    width: .32rem;
    height: .32rem;
    top: -.1rem;
    right: 0;
    background: red;
    border-radius: 50%;
  }
}
</style>
